import { Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../material.module';
import { FormFieldComponent } from '../../directives/form-field.directive';
import { TranslateModule } from '@ngx-translate/core';
import { provideValueAccessor } from '../../utils';

export interface RadioOption {
  value: any;
  label: string;
}

@Component({
  imports: [MaterialModule, ReactiveFormsModule, TranslateModule],
  selector: 'app-radio-group-form-field',
  providers: [provideValueAccessor(RadioGroupFormFieldComponent)],
  styleUrls: ['./radio-group-form-field.component.scss'],
  templateUrl: './radio-group-form-field.component.html',
})
export class RadioGroupFormFieldComponent extends FormFieldComponent<any> {
  readonly options = input<RadioOption[]>([]);
  readonly vertical = input<boolean>(false);
  readonly isDisabled = input<boolean>(false);

  set value(input: any) {
    this._value = input;
    this.onChange(input);
    this.onTouched();
  }
  get value(): any {
    return this._value;
  }

  writeValue(value: any): void {
    this._value = value;
  }
}
